import React from 'react';
import '../src/styles.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './Pages/LoginForm';
import AdminManagerTeamLeadDashboard from './Pages/AdminManagerTeamLeadDashboard';
import UserDashboard from './Pages/UserDashboard';
import Header from './Components/Header';
import Footer from './Components/Footer';
import ForgotPassword from './Pages/ForgotPassword';
import ResetPassword from './Pages/ResetPassword';
import UserProfile from './Pages/Profile';
import LeaveManagement from './Pages/LeaveManagement';
import LeaveRequest from './Pages/CreateLeaveRequest';
import LeaveBalance from './Pages/LeaveBalance';
import LeaveTransaction from './Pages/LeaveTransactions';
import AttendanceManagement from './Pages/AttendanceManagement';
import ArRequest from './Pages/CreateARRequest';
import PunchMap from './Pages/PunchMap';
import MyCalendar from './Pages/MyCalendar';
import ArTransactions from './Pages/ArTransactions';
import ArDetails from './Pages/ArRequestDetails';
import LeaveDetails from './Pages/LeaveDeatils';
import ArRequestDecision from './Pages/ArRequestDecision';
import LeaveDecision from './Pages/LeaveDecision';
import AllRequests from './Pages/AllRequests';
import EmployeeCalendar from './Pages/EmployeeCalendar';
import Calendar from './Pages/Calendar';
import Employees from './Pages/Employees';
import CreateUsers from './Pages/CreateUsers';
import AssignPage from './Pages/AssignRoleManagerLocation';
import UpdateUser from './Pages/UpdateUser';
import UserDetails from './Pages/ViewUserDetails';
import RoleOffice from './Pages/RoleOffice';
import UpdateRoleOffice from './Pages/UpdateRole&Office';
import CreateRoleOffice from './Pages/CreateRoleOffice';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import LiveTracking from './Pages/LiveTracking';
import LeavesAdmin from './Pages/LeavesAdmin';
import AttendanceAdmin from './Pages/AttendanceAdmin';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin-manager-lead-dashboard" element={<AdminManagerTeamLeadDashboard />} />
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path='/punch-map/:id' element={<PunchMap />} />
        <Route path="/user-profile/:id" element={<UserProfile />} />
        <Route path="/leave-management/:id" element={<LeaveManagement />} />
        <Route path='/leave-request/:id' element={<LeaveRequest />} />
        <Route path='/leave-balance' element={<LeaveBalance />} />
        <Route path='/leave-transaction' element={<LeaveTransaction />} />
        <Route path='/leave-details/:id' element={<LeaveDetails />} />
        <Route path='/leave-attendance/:id' element={<AttendanceManagement />} />
        <Route path='/ar-request/:id' element={<ArRequest />} />
        <Route path='/my-calendar' element={<MyCalendar />} />
        <Route path='/ar-transaction' element={<ArTransactions />} />
        <Route path='/ar-details/:id' element={<ArDetails />} />
        <Route path='/employee-calendar/:employeeId' element={<EmployeeCalendar />} />
        <Route path='/calendar' element={<Calendar />} />
        <Route path='/ar-decision/:id' element={<ArRequestDecision />} />
        <Route path='/leave-decision/:id' element={<LeaveDecision />} />
        <Route path='/all-requests' element={<AllRequests />} />
        <Route path='/employees' element={<Employees />} />
        <Route path='/create-users' element={<CreateUsers />} />
        <Route path='/assign/:userId' element={<AssignPage />} />
        <Route path='/update-user/:userId' element={<UpdateUser />} />
        <Route path='/user/:userId' element={<UserDetails />} />
        <Route path='/roles-office' element={<RoleOffice />} />
        <Route path='/update-roles/:roleId' element={<UpdateRoleOffice />} />
        <Route path='/update-location/:officeId' element={<UpdateRoleOffice />} />
        <Route path='/update-unit/:unitId' element={<UpdateRoleOffice />} />
        <Route path='/create-office' element={<CreateRoleOffice />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/live-tracking" element={<LiveTracking />} />
        <Route path="/leaves-admin" element={<LeavesAdmin />} />
        <Route path="/attendance-admin" element={<AttendanceAdmin />} />
      </Routes>
    </BrowserRouter>
  );
}

const LoginFooter = ({ children }) => {
  return (
    <>
      {children}
      <Footer />
    </>
  );
};

export default App;